import React from 'react'
import { Grid } from '@mui/material'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  return {
    list: {
      gap: '4px',
      width: '100%',
      display: 'flex',
    },
    item: {
      height: '8px',
      flex: '1 1 100%',
      borderRadius: '8px',
      border: '1px solid transparent',
    },
    itemActive: {
      borderColor: '#E4CAFB',
      backgroundColor: theme.palette.common.white,
    },
    itemPast: {
      borderColor: '#E4CAFB',
      backgroundColor: '#E4CAFB',
    },
    itemNext: {
      borderColor: '#EFECF1',
      backgroundColor: '#EFECF1',
    },
  }
})

const FormProgressBar = ({
  activeStep,
  totalSteps,
}: {
  activeStep: number
  totalSteps: number
}) => {
  const classes = useStyles()
  return (
    <Grid className={classes.list}>
      {Array.from({ length: totalSteps })
        .fill(0)
        .map((_, index) => {
          let className = classes.itemNext

          if (index === activeStep) {
            className = classes.itemActive
          } else if (index < activeStep) {
            className = classes.itemPast
          }

          return (
            <Grid className={`${classes.item} ${className}`} key={index}></Grid>
          )
        })}
    </Grid>
  )
}

export default FormProgressBar
